import React from 'react';
import Link from '../Link/Link';
import { scroller } from 'react-scroll';
import * as pcStyles from './Button.module.css';
import * as mpsStyles from './Button.mps.module.scss';
import { Spinner } from '@chakra-ui/react';
import { storeStyle } from '../../../common/util';

const styles = storeStyle({ mpsStyles, pcStyles });
const Button = ({ children, href, target, level, type, size, alternate, disabled, onClick, name, value, className, flat, link, theme , loading}) => {
  const classes = [styles.button];
  if (level in styles) {
      classes.push(styles[level])
  }
  if (size in styles) {
      classes.push(styles[size])
  }
  if (theme in styles) {
      classes.push(styles[theme])
  }
  if (alternate) {
      classes.push(styles.alternate)
  }
  if (disabled) {
      classes.push(styles.disabled)
  }
  if (flat) {
      classes.push(styles.flat)
  }
  if (link) {
      classes.push(styles.link)
  }
  if (className) {
      classes.push(className)
  }
  
  const classOutput = classes.join(' ');

  const scrollToHash = (evt) => {
      if (evt.currentTarget.getAttribute('href') && evt.currentTarget.getAttribute('href').indexOf('/#') > -1) {
          evt.preventDefault();
          const id = evt.currentTarget.getAttribute('href').split('/#')[1];
          scroller.scrollTo(
              id,
              {
                  duration: 800,
                  delay: 0,
                  offset: -180,
                  smooth: 'easeInOutQuart'
              }
          );
      }
  }

  return (
      <>
          {(type === 'inputButton' || type === 'inputSubmit') && (
              <button className={classOutput} type={type === 'inputSubmit' ? "submit" : "button"} disabled={disabled} name={name}  {...(onClick ? {onClick} : {onClick: scrollToHash})} >
                  {loading && <Spinner mr={2} size={'xs'}/>}
                  {value}
              </button>
          )}
          {(type === 'button' || type === 'buttonSubmit') && (
              <button className={`${classOutput} ${styles.base}`} type={type === 'buttonSubmit' ? "submit" : ""} disabled={disabled} {...(onClick ? {onClick} : {onClick: scrollToHash})}>
                  
                  {loading && <Spinner size={'xs'}/>}
                  {children}</button>
          )}
          {(type === 'span') && (
              <span data-button className={`${classOutput} ${styles.base}`} role="presentation" disabled={disabled} {...(onClick ? {onClick} : {onClick: scrollToHash})}>
                  {loading && <Spinner size={'xs'}/>}
                  {children}</span>
          )}
          {(!type || type === 'a') && target && (
              <a tabIndex={0} href={href} className={classOutput} {...(onClick ? {onClick} : {onClick: scrollToHash})} disabled={disabled} target="_blank" rel="noreferrer">{children}</a>
          )}
          {(!type || type === 'a') && !target && (
              <Link url={href} className={classOutput} {...(onClick ? {onClick} : {onClick: scrollToHash})} disabled={disabled}>{children}</Link>
          )}
      </>
  )
}

export default Button